import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b7bb0b48"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "spawnable-dot-annotation" }
const _hoisted_3 = { class: "type-container" }
const _hoisted_4 = { class: "type" }
const _hoisted_5 = {
  key: 0,
  class: "mouse-linked-connection-lines"
}

import {computed, onMounted, onUnmounted, PropType, Ref, ref, watch} from "vue";
import {SegmentationShortcut} from "@/components/frame/image/annotation/type/SegmentationShortcut";
import ShortcutsManager, {SPECIAL_SHORTCUT_CODE} from "@/lib/common/helpers/ShortcutsManager";
import {SSegmentedImage} from "@/store/Spatial2DAnnotation/model/SSegmentedImage";
import {SegmentedImagesStoreManager} from "@/store/Spatial2DAnnotation/manager/SegmentedImagesStoreManager";
import {SSegmentationTargetTypeParams} from "@/store/Spatial2DAnnotation/model/SSegmentationTargetTypeParams";
import {SegmentedTargetManager} from "@/store/Spatial2DAnnotation/manager/subManager/SegmentedTargetManager";
import {AbstractSubStoreManager} from "@/lib/store/manager/abstract/AbstractSubStoreManager";
import {
  SegmentationTargetTypeParamsStoreManager
} from "@/store/Spatial2DAnnotation/manager/SegmentationTargetTypeParamsStoreManager";
import ConnectionLine from "@/components/frame/image/annotation/ConnectionLine.vue";
import {onElementResize} from "@/lib/common/utilities/DomUtilities";
import DotAnnotations from "@/components/frame/image/annotation/DotAnnotations.vue";
import {SegmentationShortcutType} from "@/components/frame/image/annotation/enum/SegmentationShortcutType";
import {S2DSegment} from "@/store/Spatial2DAnnotation/model/S2DSegment";
import {SWITCH_DIRECTION} from "@/store/Spatial2DAnnotation/holder/SegmentedImagesStore";


export default /*#__PURE__*/_defineComponent({
  name: 'SegmentationOverlay',
  props: {
  segmentedImage: {
    type: Object as PropType<SSegmentedImage>,
    required: true
  }
},
  setup(__props) {

const props = __props

_useCssVars(_ctx => ({
  "46ea55bf": (cursorOnOverlayY.value),
  "46ea55be": (cursorOnOverlayX.value),
  "15b0dc82": (_unref(spawnableDotAnnotationColor))
}))




// ------------------------------
//  Overlay
// ------------------------------

const overlay = ref();

// ------------------------------
//  Bounding Box
// ------------------------------

const currentTarget = computed(() => {
  return SegmentedImagesStoreManager.store.currentSegmentedTarget;
})

// const isTargetCurrent = computed(() => {
//   return (instanceId: string) => {
//     return !!(SegmentedImagesStoreManager.store.currentSegmentedTarget && SegmentedImagesStoreManager.store.currentSegmentedTarget.instanceId === instanceId)
//   };
// });
//
// const setCurrentTarget = (target: SSegmentedTarget) =>
// {
//   if (
//       !currentTarget.value
//       || currentTarget.value.instanceId !== target.instanceId
//   )
//     SegmentedImagesStoreManager.setCurrentSegmentedTarget(target);
// }

const segmentationTargetTypeParams: Ref<SSegmentationTargetTypeParams> = computed(() => {
  return SegmentationTargetTypeParamsStoreManager.store.selected[0];
});

watch(() => segmentationTargetTypeParams.value, () => {
  SegmentedImagesStoreManager.setCurrentSegmentedTargetBasedOnType(segmentationTargetTypeParams.value.value)
})

// ------------------------------
//  Mouse position tracking
// ------------------------------

const cursorOnOverlayX = ref(),
    cursorOnOverlayY = ref(),
    isCursorInsideImage = ref(false);

onMounted(() =>
{
  overlay.value.addEventListener("mouseover", function()
  {
    isCursorInsideImage.value = true;
  });

  overlay.value.addEventListener("mousemove", function(this: HTMLElement, event: MouseEvent)
  {
    const rect = this.getBoundingClientRect();

    cursorOnOverlayX.value = (event.pageX - rect.left) + "px";
    cursorOnOverlayY.value = (event.pageY - rect.top) + "px";
  });

  overlay.value.addEventListener("mouseleave", function()
  {
    isCursorInsideImage.value = false;
  });
})

// ------------------------------
//  Shortcuts
// ------------------------------

const shortcuts: Ref<SegmentationShortcut[]> = computed(() =>
{
  const base = [
    {
      type: SegmentationShortcutType.CLEAR_CURRENT_TYPE,
      keyCode: "Escape"
    },
    {
      type: SegmentationShortcutType.DELETE_ANNOTATION_DOT,
      keyCode: SPECIAL_SHORTCUT_CODE.LEFT_CLICK,
      requiresShift: true,
    },
    {
      type: SegmentationShortcutType.SWITCH_TO_NEXT_SEGMENT,
      keyCode: SPECIAL_SHORTCUT_CODE.WHEEL_DOWN,
    },
    {
      type: SegmentationShortcutType.SWITCH_TO_PREVIOUS_SEGMENT,
      keyCode: SPECIAL_SHORTCUT_CODE.WHEEL_UP,
    },
    {
      type: SegmentationShortcutType.SWITCH_TO_PREVIOUS_TARGET,
      keyCode: SPECIAL_SHORTCUT_CODE.WHEEL_DOWN,
      requiresShift: true,
    },
    {
      type: SegmentationShortcutType.SWITCH_TO_NEXT_TARGET,
      keyCode: SPECIAL_SHORTCUT_CODE.WHEEL_UP,
      requiresShift: true,
    },
  ];

  return [
    ...base,
  ];
});

let shortcutHolderInstanceIds: string[] = [];

onMounted(() =>
{
  registerShortcuts();
})

onUnmounted(() => {
  shortcutHolderInstanceIds.forEach(shortcutHolderInstanceId => ShortcutsManager.unregister(shortcutHolderInstanceId));
})

const registerShortcuts = () =>
{
  shortcuts.value.forEach((shortcut) =>
  {
    shortcutHolderInstanceIds.push(ShortcutsManager.register(shortcut.keyCode, shortcut.requiresCtrl as boolean, shortcut.requiresAlt as boolean, shortcut.requiresShift as boolean,  () =>
    {
      switch (shortcut.type)
      {
        case SegmentationShortcutType.CLEAR_CURRENT_TYPE:
          clearCurrentType();
          break;

        case SegmentationShortcutType.DELETE_ANNOTATION_DOT:
          deleteDotAnnotation();
          break;

        case SegmentationShortcutType.SWITCH_TO_NEXT_SEGMENT:
          switchToNextSegment();
          break;

        case SegmentationShortcutType.SWITCH_TO_PREVIOUS_SEGMENT:
          switchToPreviousSegment();
          break;

        case SegmentationShortcutType.SWITCH_TO_NEXT_TARGET:
          switchToNextTarget();
          break;

        case SegmentationShortcutType.SWITCH_TO_PREVIOUS_TARGET:
          switchToPreviousTarget();
          break;
      }
    }));
  })
}

// ------------------------------
//  Clear
// ------------------------------

const isImageCurrent = computed(() => {
  return SegmentedImagesStoreManager.store.currentSegmentedImage?.instanceId === props.segmentedImage.instanceId;
});

// const clearAll = () =>
// {
//   if (isImageCurrent.value)
//     SegmentedImagesStoreManager.store.resetCurrentSegmentedImage();
// }

const clearCurrentType = () =>
{
  if (isImageCurrent.value && currentTarget.value)
    SegmentedImagesStoreManager.store.removeTarget(currentTarget.value.instanceId);
}

// ------------------------------
//  Annotation
// ------------------------------

const displayAnnotationsHolder = ref(true);

const spawnSegment = (e: MouseEvent) =>
{
  if (!e.ctrlKey && !e.altKey && !e.shiftKey && segmentationTargetTypeParams.value)
  {
    const x = +cursorOnOverlayX.value.replace("px", "");
    const y = +cursorOnOverlayY.value.replace("px", "");

    let currentTarget = SegmentedImagesStoreManager.store.currentSegmentedTarget;

    if (!currentTarget) {
      SegmentedImagesStoreManager.createEmptyTargetForCurrent(segmentationTargetTypeParams.value.value, segmentationTargetTypeParams.value.colorCode, true);
      currentTarget = SegmentedImagesStoreManager.store.currentSegmentedTarget;
    }

    if (
        x && y
        && currentTarget
        && isCursorInsideImage
        && isImageCurrent.value
    )
    {
      const segmentedTargetManager = new SegmentedTargetManager(segmentationTargetTypeParams.value.value);

      if (isHoveringTheStartSegment())
      {
        // Connect the last annotation and complete the target
        SegmentedImagesStoreManager.store.setCurrentTargetIsCompleted(true);
      }
      else
      {
        // Add an annotation
        const result = segmentedTargetManager.addSegment(currentTarget, {
          instanceId: AbstractSubStoreManager.createInstanceId(),
          left: x * 100 / overlay.value.offsetWidth,
          top: y * 100 / overlay.value.offsetHeight,
          type: currentTarget.type,
          colorCode: currentTarget.colorCode
        }, currentTarget.nextInsertableSegmentIndex);

        if (Array.isArray(result))
          throw "Couldn't create annotation. Errors : " + result.join(", ");
      }

      SegmentedImagesStoreManager.store.incrementNextInsertableSegmentIndexForCurrentTarget();

      // Doing this forces the dot annotations' re-render and is being done invisibly using a transition
      displayAnnotationsHolder.value = false;
      setTimeout(() => {
        displayAnnotationsHolder.value = true;
      }, 5);
    }
  }
}

const isHoveringTheStartSegment = () =>
{
  if (!currentTarget.value || !currentTarget.value.segments.length)
    return false;

  const firstSegmentInstanceId = currentTarget.value.segments[0].instanceId;

  return hoveredSegments.value.filter(segment => segment.instanceId === firstSegmentInstanceId).length > 0;
}

// ------------------------------
//  Target
// ------------------------------

const switchToNextTarget = () => {
  if (isImageCurrent.value)
    SegmentedImagesStoreManager.store.switchToNextOrPreviousTarget({direction: SWITCH_DIRECTION.NEXT, allowIsComplete: true});
}

const switchToPreviousTarget = () => {
  if (isImageCurrent.value)
    SegmentedImagesStoreManager.store.switchToNextOrPreviousTarget({direction: SWITCH_DIRECTION.PREVIOUS, allowIsComplete: true});
}

// ------------------------------
//  Spawnable annotation
// ------------------------------

const switchToNextSegment = () => {
  if (isImageCurrent.value)
    SegmentedImagesStoreManager.store.switchToNextOrPreviousNextInsertableSegmentIndexForCurrentTarget({direction: SWITCH_DIRECTION.NEXT});
}

const switchToPreviousSegment = () => {
  if (isImageCurrent.value)
    SegmentedImagesStoreManager.store.switchToNextOrPreviousNextInsertableSegmentIndexForCurrentTarget({direction: SWITCH_DIRECTION.PREVIOUS});
}

// const switchToNextSpawnableAnnotation = () => {
//   if (isImageCurrent.value)
//     SegmentationTargetTypeParamsStoreManager.store.switchToNextSelected();
// }

// const switchToPreviousSpawnableAnnotation = () => {
//   if (isImageCurrent.value)
//     SegmentationTargetTypeParamsStoreManager.store.switchToPreviousSelected();
// }

const spawnableDotAnnotationDisplayParams = computed(() => {
  return SegmentationTargetTypeParamsStoreManager.store.selected;
})

const spawnableDotAnnotationConnectionLinesParams = ref();

const nextInsertableSegmentIndexForCurrentTarget = computed(() => {
  return SegmentedImagesStoreManager.store.nextInsertableSegmentIndexForCurrentTarget;
})

const spawnableDotAnnotationName = computed(() => {
  return spawnableDotAnnotationDisplayParams.value.length ? spawnableDotAnnotationDisplayParams.value[0].value : undefined;
})

const spawnableDotAnnotationColor = computed(() => {
  return spawnableDotAnnotationDisplayParams.value.length ? spawnableDotAnnotationDisplayParams.value[0].colorCode : undefined;
})

// ------------------------------
//  Connecting lines
// ------------------------------

const forceConnectingLineRedraw = ref(0);

// watch(() => currentTarget.value, () => {
//   setTimeout(() => forceConnectingLineRedraw.value++, 50);
// })

watch(() => SegmentedImagesStoreManager.store.nextSegmentsAroundNextInsertableSegmentIndexForCurrentTarget, () => {
  setTimeout(() => spawnableDotAnnotationConnectionLinesParams.value = SegmentedImagesStoreManager.store.nextSegmentsAroundNextInsertableSegmentIndexForCurrentTarget, 50);
  setTimeout(() => forceConnectingLineRedraw.value++, 50);
})

watch(() => SegmentationTargetTypeParamsStoreManager.store.selected, () => {
  setTimeout(() => forceConnectingLineRedraw.value++, 50);
})

watch(() => isCursorInsideImage.value, () => {
  setTimeout(() => forceConnectingLineRedraw.value++, 50);
})

onMounted(() => {
  onElementResize(overlay.value, () => forceConnectingLineRedraw.value++);
})

// ------------------------------
//  Annotations deletion
// ------------------------------

const hoveredSegments: Ref<S2DSegment[]> = ref([]);

const onHoveredAnnotations = (annotations: S2DSegment[]) =>
{
  hoveredSegments.value = annotations;
}

const deleteDotAnnotation = () =>
{
  hoveredSegments.value.map(dotAnnotation => {
    SegmentedImagesStoreManager.removeSegmentOfInstanceIdFromCurrentTarget(dotAnnotation.instanceId);
  })
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass('image-overlay ' + (_unref(spawnableDotAnnotationName) ? 'ready-to-annotate' : '')),
    id: 'image-overlay-' + __props.segmentedImage.image.instanceId,
    onClick: spawnSegment,
    ref_key: "overlay",
    ref: overlay
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.segmentedImage.targets, (target) => {
      return (_openBlock(), _createElementBlock("div", {
        key: target.instanceId
      }, [
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(DotAnnotations, {
              "dot-annotations": target.segments,
              "parent-target": target,
              "parent-overlay-ref": overlay.value,
              "force-connecting-line-redraw": forceConnectingLineRedraw.value,
              "undisplay-connecting-lines-of-dot-annotations-index": (isCursorInsideImage.value && _unref(currentTarget) && _unref(currentTarget).instanceId === target.instanceId) ? _unref(nextInsertableSegmentIndexForCurrentTarget) : undefined,
              onOnHoveredAnnotations: onHoveredAnnotations
            }, null, 8, ["dot-annotations", "parent-target", "parent-overlay-ref", "force-connecting-line-redraw", "undisplay-connecting-lines-of-dot-annotations-index"]), [
              [_vShow, displayAnnotationsHolder.value && _unref(isImageCurrent)]
            ])
          ]),
          _: 2
        }, 1024)
      ]))
    }), 128)),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(spawnableDotAnnotationName)), 1)
      ])
    ], 512), [
      [_vShow, _unref(isImageCurrent) && isCursorInsideImage.value && _unref(spawnableDotAnnotationName)]
    ]),
    (_unref(currentTarget) && displayAnnotationsHolder.value)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(spawnableDotAnnotationConnectionLinesParams.value, (surroundingSegment, index) => {
            return (_openBlock(), _createBlock(ConnectionLine, {
              color: surroundingSegment ? surroundingSegment.colorCode : 'transparent',
              "to-element-id": surroundingSegment ? 'dot-annotation-' + surroundingSegment.instanceId + '-' + surroundingSegment.type : 'dot-annotation-unknown',
              "from-element-id": "cursor-follower",
              "force-redraw": forceConnectingLineRedraw.value,
              key: index
            }, null, 8, ["color", "to-element-id", "force-redraw"]))
          }), 128))
        ], 512)), [
          [_vShow, _unref(currentTarget) && _unref(isImageCurrent) && isCursorInsideImage.value && _unref(spawnableDotAnnotationName)]
        ])
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})